import { io, Socket } from 'socket.io-client';
import config from '../config/environment';

class SocketService {
  private socket: Socket | null = null;
  private projectId: string | null = null;

  connect() {
    if (this.socket?.connected) {
      return this.socket;
    }

    this.socket = io(config.socketUrl, {
      withCredentials: true,
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('Connected to socket server');
      
      // Re-join project room if we were in one
      if (this.projectId) {
        this.joinProject(this.projectId);
      }
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from socket server');
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      if (this.projectId) {
        this.leaveProject(this.projectId);
      }
      this.socket.disconnect();
      this.socket = null;
      this.projectId = null;
    }
  }

  joinProject(projectId: string) {
    if (!this.socket) {
      this.connect();
    }
    
    if (this.projectId && this.projectId !== projectId) {
      this.leaveProject(this.projectId);
    }

    this.projectId = projectId;
    this.socket?.emit('join-project', projectId);
  }

  leaveProject(projectId: string) {
    this.socket?.emit('leave-project', projectId);
    if (this.projectId === projectId) {
      this.projectId = null;
    }
  }

  // Event listeners
  on(event: string, callback: (...args: any[]) => void) {
    this.socket?.on(event, callback);
  }

  off(event: string, callback?: (...args: any[]) => void) {
    this.socket?.off(event, callback);
  }

  // Emit events (for future use if needed)
  emit(event: string, data?: any) {
    this.socket?.emit(event, data);
  }

  // Get connection status
  get connected() {
    return this.socket?.connected ?? false;
  }

  get currentProjectId() {
    return this.projectId;
  }
}

// Export a singleton instance
export const socketService = new SocketService();
export default socketService;